/* src/app/ship/pickup-locations/components/search/pickup-location-search.component.scss */
.address-title-container {
  display: flex;
}
.address-title {
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.5rem 0.5rem 0.5rem 2rem;
}
.address-title + .address-panel {
  display: flex;
}
.address-panel {
  margin-top: 1px;
  border-bottom: solid thin rgba(0, 0, 0, 0.12);
}
.address-panel .address-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.address-panel .address-content .address {
  font-size: 0.8rem;
  font-weight: 500;
}
.address-panel .address-content .address-actions [class^=material-symbols-] {
  font-size: 1.25rem;
}
.address-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.address-form .form-fields {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  column-gap: 1rem;
  flex-wrap: wrap;
  padding: 0 1rem;
}
.address-form .form-fields ::ng-deep .mat-mdc-form-field {
  width: 100%;
  font-size: 0.8rem;
  line-height: 1;
}
@media screen and (min-width: 48rem) {
  .address-form .form-fields ::ng-deep .mat-mdc-form-field {
    width: calc(50% - 0.5rem);
  }
}
.address-form .form-fields ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  height: 2.25rem;
}
.address-form .form-fields ::ng-deep .mat-mdc-form-field .mdc-floating-label:not(.mdc-floating-label--float-above) {
  top: 50%;
}
.address-form .actions {
  width: 100%;
  padding: 0 1rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-end;
}
.address-form .filters {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 1rem 1rem;
  font-size: 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: rgba(0, 0, 0, 0.02);
  border-bottom: solid thin rgba(0, 0, 0, 0.12);
}
.address-form .filters .filter {
  padding: 0 0.5rem;
}
@media screen and (min-width: 48rem) {
  .address-form .filters .filter {
    width: auto;
  }
}
.address-form .filters .filter.range {
  position: relative;
  flex-grow: 1;
}
@media screen and (min-width: 48rem) {
  .address-form .filters .filter.range {
    flex-grow: 0;
  }
}
.address-form .filters .filter.range .mat-mdc-slider {
  width: 10rem;
}
.address-form .filters .filter.range mat-label {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-1.75em) translateY(0.3em) scale(0.75) perspective(100px) translateZ(0.001px);
  width: 133.3333333333%;
  color: rgba(0, 0, 0, 0.58);
}
.address-form .filters .filter.range .range-text {
  display: inline-block;
  padding-top: 1.5rem;
}
.address-form .filters .filter.record-count {
  width: 8rem;
  margin-top: 1rem;
}
.address-form .filters .filter.record-count .mat-mdc-form-field {
  width: 100%;
}
:host(.pickup-location-search) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  background-color: white;
}
/*# sourceMappingURL=pickup-location-search.component.css.map */
